<template>
    <div>
        <FormKit
            type="hidden"
            :name="`components[${index}][component_type]`"
            :value="component.component_type"
        />
        <FormKit
            label="Header titel"
            type="text"
            :name="`components[${index}][title]`"
            :value="modelValue.title"
            @input="(value) => update('title', value)"
        />

        <button type="button" class="btn btn-primary" @click="add">
            Sectie toevoegen
        </button>

        <hr />

        <div
            v-for="(section, sectionIndex) in component.sections"
            :key="sectionIndex"
        >
            <FormKitCKEditor
                :name="`components[${index}][sections][${sectionIndex}][description]`"
                v-model="component.sections[sectionIndex].description"
                label="Text sectie"
            />
        </div>
    </div>
</template>

<script>
import mixin from "../mixins/component";
import FormKitCKEditor from "../../components/FormKitCKEditor.vue";

export default {
    components: { FormKitCKEditor },
    name: "PageDoubleGrid",
    mixins: [mixin],
    data() {
        return {
            component: {
                ...this.modelValue,
                sections: [...(this.modelValue?.sections ?? [])],
            },
        };
    },
    methods: {
        add() {
            this.component.sections.push({
                description: "",
            });
        },
    },
};
</script>
